import * as routeHelpers from "../../lib/routeHelpers";
import ManagerLinks from "../ManagerLinks";
import React, {useEffect} from "react";
import styles from "./ManagerMenu.module.css";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useAppSelector} from "../../lib/hooks";

export default function ManagerMenu() {
    const location = useLocation();
    const navigate = useNavigate();

    const cashier = useAppSelector((state) => state.pos.station.cashier);

    useEffect(() => {
        if (
            cashier.type === "user" &&
            location.pathname !== routeHelpers.managerMenu()
        ) {
            navigate(routeHelpers.managerMenu(), {replace: true});
        }
    }, [cashier.type]);

    return (
        <>
            <ManagerLinks className={styles.links} />
            <div className={styles.right}>
                <Outlet />
            </div>
        </>
    );
}
